import { CLOSE, STOP_RULESET } from "./resultTypes";

var ResultItem = (function () {
    function create(status) {
        return {
            status: status,
            shouldStop: (status === CLOSE || status === STOP_RULESET)
        };
    }

    return {
        create: create
    };
})();


export default ResultItem;